import React from "react";

export type InstallationData = {
  configuration: { [key: string]: any };
  serverConfiguration?: { [key: string]: any };
};

export type AppConfigurationExtensionContextType = {
  appUpdated: boolean;
  installationData: InstallationData;
  setInstallationData: (installationData: InstallationData) => Promise<void>;
  loading: boolean;
  token: string;
  refreshToken: () => Promise<string>;
};

export const AppConfigurationExtensionContext = React.createContext<AppConfigurationExtensionContextType>({
  appUpdated: true,
  installationData: {
    configuration: {},
    serverConfiguration: {},
  },
  setInstallationData: async () => {},
  loading: false,
  token: '',
  refreshToken: async () => '',
});
